import { Box, Icon, Typography } from "@mui/material";
import { BsCardChecklist, BsShop } from "react-icons/bs";
import { MdLocationPin, MdOutlinePhone, MdPhone } from "react-icons/md";
import phoneNumberFormatter from "../globalFunction/telefon";
import { CgOrganisation } from "react-icons/cg";

const ViewManager = ({ obj, data, type = "client", width = "100%" }) => {
    // console.log(obj)
  const clientObj = [
    {
      name_uz: "F.I.SH",
      value: obj.name,
      icon: <BsCardChecklist />,
    },
    {
      name_uz: "Manzili",
      value: data.address,
      icon: <MdLocationPin />,
    },
    {
      name_uz: "Telefon raqami",
      value: phoneNumberFormatter(obj.phoneNumber),
      icon: <MdOutlinePhone />,
    },
    {
      name_uz: "Telefon raqami 2",
      value: phoneNumberFormatter(obj.phoneNumber2),
      icon: <MdPhone />,
    },
    {
      name_uz: "Do'kon nomi",
      value: obj.market?.name ?? '-',
      icon: <CgOrganisation />,
    },
    {
      name_uz: "Do'kon raqami",
      value: obj?.storeNumber ?? '-',
      icon: <BsShop />,
    },
  ];
  return (
    <Box
      sx={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        gap: "0.5rem",
        width,
        m: "1rem auto",
      }}
    >
      <Box
        sx={{
          backgroundColor: "action.hover",
          padding: "0.2rem 0.5rem",
          borderRadius: "0.5rem",
          position: "relative",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "0",
            left: "0",
            backgroundColor: "#0088cc30",
            padding: "0.2rem 2rem",
            borderRadius: "0.5rem",
          }}
        >
          <Typography variant="body1">Mijoz malumotlari</Typography>
        </Box>
        <Box
          sx={{
            position: "absolute",
            top: "0",
            right: "0",
            padding: "0.2rem 2rem",
            borderRadius: "0.5rem",
          }}
        >
          <Typography variant="body2">ID : {data.cbClient?.id}</Typography>
        </Box>
        <Box
          sx={{
            mt: "2rem",
            padding: 2,
          }}
        >
          {clientObj.map((item, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                borderBottom: "1px solid #e0e0e0",
                padding: "0.5rem 0",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Icon>{item.icon}</Icon>
                <Typography variant="caption">{item.name_uz}</Typography>
              </Box>
              <Typography variant="caption">{item.value}</Typography>
            </Box>
          ))}
        </Box>
          {
              obj.longitude && obj.latitude &&
              <div>
                  <iframe
                        title="store-location"
                      width="100%"
                      height="450"
                      // share option
                      src={`https://maps.google.com/maps?q=${obj.latitude},${obj.longitude}&z=16&output=embed`}
                      loading="lazy"
                  />
              </div>
          }
      </Box>
    </Box>
  );
};

export default ViewManager;
